import React from 'react';
import styles from './Header.module.scss'
import {ReactComponent as Logo}from './../../images/logo.svg'

const Header = () => {
    return (
        <header className={styles.header}>
            <div className={styles.logo}>
                <Logo/>
                <div className={styles.textContainer}>
                    <p className={styles.logoText}>Правительство</p>
                    <p className={styles.logoText}>Белгородской области</p>
                </div>
            </div>
            <p className={styles.description}>Региональный проект для участников СВО</p>
        </header>
    )
};

export default Header;